/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Note_2_DescriptionInputs */

const en_homepage_features_note_2_description = /** @type {(inputs: Homepage_Features_Note_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Researchers forget 70% in 24 hours unless recorded. 1 click captures key notes (without the gruntwork!`)
};

const es_homepage_features_note_2_description = /** @type {(inputs: Homepage_Features_Note_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los investigadores olvidan el 70% en 24 horas si no lo registran. 1 clic captura notas clave (¡sin el trabajo tedioso!`)
};

/**
* | output |
* | --- |
* | "Researchers forget 70% in 24 hours unless recorded. 1 click captures key notes (without the gruntwork!" |
*
* @param {Homepage_Features_Note_2_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_note_2_description = /** @type {((inputs?: Homepage_Features_Note_2_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Note_2_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_note_2_description(inputs)
	return en_homepage_features_note_2_description(inputs)
});